import { useQuery } from '@tanstack/react-query';
import couponsApi from '../api/coupons';

export const couponVerificationOptions = (code, accessToken, day) => ({
  queryKey: ['coupon-verification', code, accessToken ?? null, day],
  queryFn: async () => {
    const result = await couponsApi(accessToken).verifyCoupon(code);
    if (result.invalid) return { status: 'invalid', summary: null, message: result.invalid, reason: result.reason };
    if (result.data?.code !== code) throw new Error(result.error || 'Unable to verify this coupon.');
    return { status: 'valid', summary: result.data, message: null };
  },
  staleTime: Infinity,
  gcTime: 0,
  retry: 1,
  refetchOnWindowFocus: (query) => query.state.status === 'error',
  refetchOnReconnect: (query) => query.state.status === 'error',
});

const useCouponVerification = (code, accessToken, day, enabled) =>
  useQuery({ ...couponVerificationOptions(code, accessToken, day), enabled });

export default useCouponVerification;
